import { FullScreenModal } from "@circle-react-shared/ModalsV2/FullScreenModal";
import { ModalCloseButton } from "@circle-react-shared/ModalsV2/FullScreenModal/components/ModalCloseButton";
import { Loader } from "@circle-react-shared/uikit/Loader";
import { useSmScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";

import { t } from "@/i18n-js/instance";
import { useConfirmAndDeclineButton } from "@/react/components/Paywalls/CheckoutWithSession/pages/OfferPage/hooks/useConfirmAndDeclineButton";
import { ActionModal } from "@/react/components/SettingsApp/CompassCompat/ActionModal";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";
import { Typography } from "@/react/components/SettingsApp/CompassCompat/Typography";

import { CheckoutDescription } from "..";
import {
  OfferPageContextProvider,
  useOfferPageContext,
} from "../../../../CheckoutWithSession/pages/OfferPage/OfferPageProvider";
import { ModalPreview } from "../../CheckoutForm/PricePreview/ModalPreview";
import { usePaywallCustomizationContext } from "../PaywallCustomization/PaywallCustomizationProvider";

interface PriceSelectorModalProps {
  isOpen: boolean;
  onClose: () => void;
  stepId: string | number;
}

export const PriceSelectorModal = ({
  stepId,
  onClose,
  isOpen,
}: PriceSelectorModalProps) => {
  const { isProcessingAttempt, shouldBlockButtons, handleConfirm } =
    useConfirmAndDeclineButton();
  const { paywall } = useOfferPageContext();
  const { paywallCustomization } = usePaywallCustomizationContext();

  const onClick = () => {
    handleConfirm();
    onClose();
  };

  const isSmScreen = useSmScreenMediaQuery();

  if (isSmScreen) {
    return (
      <FullScreenModal
        isOpen={isOpen}
        onClose={onClose}
        shouldShowCloseButton
        className="!h-auto !max-h-[95%] rounded-t-xl"
      >
        <FullScreenModal.Header className="border-none !py-4">
          <div className="flex w-full flex-row items-center justify-between">
            <Typography.TitleMd weight="font-bold">
              {t("paywall_checkout.order_summary")}
            </Typography.TitleMd>
            <ModalCloseButton onClick={onClose} />
          </div>
        </FullScreenModal.Header>
        <FullScreenModal.Body className="px-5 pb-8">
          <OfferPageContextProvider
            paywall={paywall}
            paywallCustomization={paywallCustomization}
            stepId={stepId}
          >
            <div className="flex flex-col gap-y-4">
              <CheckoutDescription.PriceSelector
                useHooks={useOfferPageContext}
              />
              <ModalPreview.OfferPagePreview />
            </div>
          </OfferPageContextProvider>
        </FullScreenModal.Body>
        <FullScreenModal.Footer>
          <Button
            variant="circle"
            full
            type="button"
            onClick={onClick}
            disabled={shouldBlockButtons}
          >
            {isProcessingAttempt ? (
              <Loader />
            ) : (
              t("paywall_checkout.offer_page.confirm_add_to_my_order")
            )}
          </Button>
        </FullScreenModal.Footer>
      </FullScreenModal>
    );
  }

  return (
    <ActionModal
      title={t("paywall_checkout.order_summary")}
      titleClassName="!text-left !px-0"
      onClose={onClose}
      isOpen={isOpen}
      actionText={t("paywall_checkout.offer_page.confirm_add_to_my_order")}
      actionVariant="circle"
      onAction={onClick}
      disabled={shouldBlockButtons}
      isFullWidthAction
    >
      <OfferPageContextProvider
        paywall={paywall}
        paywallCustomization={paywallCustomization}
        stepId={stepId}
      >
        <div className="flex flex-col gap-y-4">
          <CheckoutDescription.PriceSelector useHooks={useOfferPageContext} />
          <ModalPreview.OfferPagePreview />
        </div>
      </OfferPageContextProvider>
    </ActionModal>
  );
};
